/**
 * @description
 */
export enum ParentEnvelope {
	DEV_INT = 'ParentEnvelope.DEV_INT',
	LOCALHOST = 'ParentEnvelope.LOCALHOST',
	PREVIEW_CBS = 'ParentEnvelope.PREVIEW_CBS',
	PREVIEW_INT = 'ParentEnvelope.PREVIEW_INT',
	PREVIEW_PPLUS = 'ParentEnvelope.PREVIEW_PPLUS',
	PROD_CBS = 'ParentEnvelope.PROD_CBS',
	PROD_INT = 'ParentEnvelope.PROD_INT',
	PROD_PPLUS = 'ParentEnvelope.PROD_PPLUS',
	SHADOW_CBS = 'ParentEnvelope.SHADOW_CBS',
	SHADOW_INT = 'ParentEnvelope.SHADOW_INT',
	SHADOW_PPLUS = 'ParentEnvelope.SHADOW_PPLUS',
	STAGE_CBS = 'ParentEnvelope.STAGE_CBS',
	STAGE_INT = 'ParentEnvelope.STAGE_INT',
	STAGE_PPLUS = 'ParentEnvelope.STAGE_PPLUS',
	TEST_WWW_CBS = 'ParentEnvelope.TEST_WWW_CBS',
	TEST_WWW_PPLUS = 'ParentEnvelope.TEST_WWW_PPLUS',
	VIDOPSTEST_CBS = 'ParentEnvelope.VIDOPSTEST_CBS',
	VIDOPSTEST_INT = 'ParentEnvelope.VIDOPSTEST_INT',
	VIDOPSTEST_PPLUS = 'ParentEnvelope.VIDOPSTEST_PPLUS',
}